export default {
  manage_editFuelCard_modalTitle: "Edit Fuel Card",
  manage_editFuelCard_typeOfAssignmentSelectLabel: "Unit / Driver",
  manage_editFuelCard_typeOfAssignment_unassignment: "Unassigned",
  manage_editFuelCard_typeOfAssignment_unit: "Unit",
  manage_editFuelCard_typeOfAssignment_driver: "Driver",
  manage_editFuelCard_tankSize: "Tank Size (Value in Gallons)",
  manage_editFuelCard_success: "Fuel Card was updated successfully",
  manage_editFuelCard_tankSize_error: "Tank Size cannot be greater than 1000"
};
